
import vClickOutside from 'v-click-outside';
export default {
    name: 'LanguageSwitch',
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            isShow: false
        };
    },
    computed: {
        currentLocaleName() {
            return this.$i18n.locales.filter(i => i.code === this.$i18n.locale)[0]?.code;
        },
        isClient() {
            return process.client;
        }
    },
    methods: {
        closeLangMenu() {
            this.isShow = false;
        }
    }
};
